import type { ChangelogEntry } from "../types";

/** Produktdata per modell: produsentbilder, manualer og spesifikasjoner hentet med gjennomsyn. */
export const UTSTYR_PRODUKTDATA_2026_10: ChangelogEntry = {
  id: "2026-10-24-utstyr-produktdata",
  date: "2026-10-24",
  title: "Manualer og produsentbilder på utstyrskortet",
  summary:
    "Utstyr er koblet til en modell, og manual, datablad, produktbilde og spesifikasjoner hentes fra produsenten én gang per modell. Ingenting lagres før noen har valgt det.",
  sections: [
    {
      heading: "Utstyr",
      minRole: "user",
      items: [
        {
          title: "Dokumenter og produsentbilde",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Utstyrskortet viser manual og datablad under Dokumenter, og produsentbildet når utstyret ikke har eget bilde. Alt utstyr av samme modell deler dem, i begge avdelinger. Manualene ligger i Revehiet og kan åpnes på mobil.",
        },
      ],
    },
    {
      heading: "For administratorer og utstyrsansvarlige",
      minRole: "admin",
      items: [
        {
          title: "Hent produktdata",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Knappen på utstyrskortet henter bilder, dokumenter og spesifikasjoner fra produsentens nettside. Du krysser av for det som skal lagres; resten forkastes. Treff som ikke er fra produsenten, og mulige feil varianter, er merket.",
        },
        {
          title: "Produktdata for alle modeller",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Utstyr, Produktdata viser hver modell med status, gjenværende credits hos datakilden og «Hent for alle uten data». Forslagene gås gjennom ett og ett med «Se forslag».",
        },
      ],
    },
  ],
};
